import "handsontable/dist/handsontable.full.min.css";
import { CellProperties } from "handsontable/settings";
import { TextEditor } from "handsontable/editors";
import Core from "handsontable/core";
import { MatrixParameterValue } from "../interfaces/MatrixInputCell";

class CustomTextEditor extends TextEditor {
  originalValue: MatrixParameterValue | undefined;

  constructor(instance: Core, originalValue: MatrixParameterValue) {
    super(instance);
    this.originalValue = originalValue;
  }

  prepare(
    row: number,
    col: number,
    prop: string | number,
    td: HTMLTableCellElement,
    originalValue: MatrixParameterValue,
    cellProperties: CellProperties,
  ) {
    super.prepare(row, col, prop, td, originalValue, cellProperties);
  }

  getValue() {
    if (this.originalValue) {
      this.originalValue.parameterValue.value = (this.TEXTAREA as HTMLInputElement).value;
      this.TEXTAREA_PARENT.appendChild(this.TEXTAREA);
    }
    return this.originalValue;
  }

  setValue(newValue?: any): void {
    if (newValue === "[object Object]") {
      return;
    }

    if (typeof newValue === "object") {
      this.originalValue = newValue;
    }
  }
}

export default CustomTextEditor;
